import { render, staticRenderFns } from "./CmgReferralNotEligibleModal.vue?vue&type=template&id=132d5e42&scoped=true&lang=pug"
import script from "./cmg-referral-not-eligible-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-referral-not-eligible-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgReferralNotEligibleModal.vue?vue&type=style&index=0&id=132d5e42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132d5e42",
  null
  
)

export default component.exports